import React, {useEffect} from 'react';
import {
    Container,
    SubContentList,
    ContentList,
} from "./styled";
import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {UserController} from "@dropDesk/presentation/pages/user/controller/user.controller";
import SearchBar from "@dropDesk/presentation/pages/user/ui/search/search_bar";
import TableUsers from "@dropDesk/presentation/pages/user/ui/search/table";
import ModalsUsers from "@dropDesk/presentation/pages/user/ui/search/modals";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import toastMessage from "@dropDesk/utils/toast_message/toast_message";
import {useTranslation} from "react-i18next";
import DropDeskLoading from "@dropDesk/presentation/components/loadings/loading_dropdesk";
import FooterGarbage from "@dropDesk/presentation/components/footer/footer_garbage";

const Users = (observer(() => {

    const controller = useInjection(UserController);
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const userLogged = appController.user!;
    const {t} = useTranslation();
    const heightGarbage = appController.user?.permissionDeleteData ? 0 : 50;

    useEffect(() => {
        controller.initialize(appController.incrementHeight(heightGarbage));
    }, []);

    const onSuccessDeleteOrRestore = (key: string) => {
        controller.list(controller.searchParam);
        toastMessage.success(t(key));
    }

    return (
        <Container background={colors.onBackground}>
            <ContentList>
                <SearchBar
                    onSearch={(searchParam) => controller.list(searchParam)}
                    visibleInputSearch={controller.rowSelectionUsers.length === 0}
                    loading={controller.loading}
                    visibleButtonsOfActions={!controller.listOnlyDeleted && controller.rowSelectionUsers.length === 0}
                    visibleButtonDeleted={!controller.listOnlyDeleted && controller.rowSelectionUsers.length > 0}
                    visibleButtonRestore={controller.listOnlyDeleted && controller.rowSelectionUsers.length > 0}
                />
                <SubContentList>

                    <TableUsers
                        setUser={(user) => controller.setUser(user)}
                        permitDeleteUser={(user) => controller.permitDeleteUser(user, userLogged)}
                        rowSelectionUsers={controller.rowSelectionUsers}
                        setRowSelectionUsers={(users: UserEntity[]) => controller.setRowSelectionUsers(users)}
                        getDataFromPage={(page) => controller.getDataFromPage(page)}
                        tableUsers={controller.tableUsers}
                        searchParam={controller.searchParam}
                        loading={controller.loading}
                        permitSelectionRow={controller.listOnlyDeleted}
                        heightGarbage={heightGarbage}
                        permissionDeleteData={appController.user?.permissionDeleteData ?? false}
                    />

                    {appController.user?.permissionDeleteData && <FooterGarbage
                        setListOnlyDeleted={(value) => controller.setListOnlyDeleted(value)}
                        visibleListOnlyDeleted={controller.listOnlyDeleted}
                        loading={controller.loading}
                        text={'Atendentes ativos'}
                        textDelete={'Atendentes excluídos'}
                    />}

                    <ModalsUsers
                        removeLineSelectRow={() => controller.removeLineSelectRow()}
                        restoreUser={() => controller.restore(onSuccessDeleteOrRestore)}
                        deleteUser={() => controller.delete(onSuccessDeleteOrRestore)}
                        loading={controller.loading}
                    />
                </SubContentList>
            </ContentList>

            {(controller.loading && controller.loadingMessage) && <DropDeskLoading
                height={250}
                description={controller.loadingMessage}
            />}
        </Container>
    )

}))
export default Users;
